import React from 'react';
import PropTypes from 'prop-types';
import { Empty, Typography, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import RCTable from 'components/custom-table/RCTable';

const { Text } = Typography;

function PaymentHistoryTab({ tableDatas, togglePaginate, dispatchAction }) {
	const navigate = useNavigate();

	const handleView = (record) => {
		navigate(`/finance/requests/${record.id}?sourceTab=payment-history`);
	};

	const columns = [
		{
			title: 'Trip ID',
			dataIndex: 'trip_id',
			key: 'trip_id',
			width: 90,
			render: (trip_id) => <Text overFlow="hidden">{trip_id || '-'}</Text>,
		},
		{
			title: 'Req ID',
			dataIndex: 'adhoc_request_id',
			key: 'adhoc_request_id',
			width: 100,
		},
		{
			title: 'Request Type',
			dataIndex: 'request_type',
			key: 'request_type',
			width: 120,
		},
		{
			title: 'Business Unit',
			dataIndex: 'business_unit_name',
			key: 'business_unit_name',
			width: 130,
		},
		{
			title: 'Party Name',
			dataIndex: 'party_name',
			key: 'party_name',
			width: 120,
		},
		{
			title: 'Request Date',
			dataIndex: 'request_date',
			key: 'request_date',
			width: 150,
			render: (date) => {
				if (!date) return '-';
				return moment(date).add(5, 'hours').add(30, 'minutes').format('DD/MM/YYYY h:mm A');
			},
		},
		{
			title: 'Request value',
			dataIndex: 'request_value',
			key: 'request_value',
			width: 130,
			render: (value) => (value ? `₹${parseFloat(value).toLocaleString('en-IN')}` : '-'),
		},
		{
			title: 'Payable Value',
			dataIndex: 'paid_amount',
			key: 'paid_amount',
			width: 130,
			render: (value) => (value ? `₹${parseFloat(value).toLocaleString('en-IN')}` : '-'),
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: 150,
			render: (text) => <span>{text || '-'}</span>,
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			width: 120,
			render: (_, record) => (
				<Button type="link" icon={<EyeOutlined />} onClick={() => handleView(record)} />
			),
		},
	];

	return (
		<div style={{ marginTop: 16 }}>
			<RCTable
				rowKey="id"
				tableDatas={tableDatas}
				togglePaginate={togglePaginate}
				dispatchAction={dispatchAction}
				columns={columns}
				scroll={{ x: true }}
				locale={{
					emptyText: (
						<Empty
							description={<Text type="secondary">No payment history found</Text>}
						/>
					),
				}}
			/>
		</div>
	);
}

PaymentHistoryTab.propTypes = {
	tableDatas: PropTypes.array.isRequired,
	togglePaginate: PropTypes.array.isRequired,
	dispatchAction: PropTypes.func.isRequired,
};

export default PaymentHistoryTab;
